import { createContext, useContext } from "react";

/**
 * ADR-20261016-6xax (AC-30 refresh): whether ANY port the composition
 * root (App.tsx) bound this session carries `isSampleData: true`. Set
 * once, from the OR of every bound port's own `isSampleData` flag — never
 * computed here, and never a second source of truth for which ports are
 * real. `PortalHeader` reads this through `useSampleData()` to decide
 * whether to render the "Sample data" marker, replacing the former
 * `!import.meta.env.PROD` build-time proxy now that a real, non-stub
 * `RenewalSummaryPort` implementation exists to distinguish itself from a
 * stub one.
 *
 * A Context, not a prop threaded through `PortalLayout` and its ~17
 * callers: `PortalLayout`'s own composition (`PortalHeader` is internal
 * to it, never passed a prop by a screen) means every one of those
 * callers would otherwise need an `isSampleData` prop of its own, for a
 * value no screen actually decides — only the composition root does.
 *
 * Defaults to `false` so a render with no provider (a unit test that
 * mounts `PortalHeader`/`PortalLayout` directly, or a production build
 * that somehow never wraps one) shows no marker — never a false
 * positive.
 */
export const SampleDataContext = createContext<boolean>(false);

export function useSampleData(): boolean {
  return useContext(SampleDataContext);
}
